import { useState } from 'react';
import { archiveGroups } from '@/mocks/heiLiao';

export default function ArchiveTabs() {
  const [active, setActive] = useState(archiveGroups[0].key);

  return (
    <section id="archive" className="mx-auto w-full max-w-[1440px] scroll-mt-24 px-4 py-6 md:px-6">
      <div className="rounded-2xl border border-background-200/70 bg-background-50">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200/60 px-4 py-3.5 md:px-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-stack-fill text-base"></i>
            </span>
            <div>
              <h2 className="font-heading text-lg leading-tight text-foreground-950">新鲜黑料 · 档案合辑</h2>
              <p className="text-[11px] text-foreground-500">按题材归档，一条不落地汇总今日新料</p>
            </div>
          </div>
        </div>

        {/* Tab 切换 */}
        <div className="flex gap-1.5 overflow-x-auto border-b border-background-200/60 bg-background-100/40 px-4 py-1.5 no-scrollbar md:px-5">
          {archiveGroups.map((g) => (
            <button
              key={g.key}
              onClick={() => setActive(g.key)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-[12px] font-medium transition-colors ${
                active === g.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:bg-background-200/60'
              }`}
            >
              {g.label}
              <span className={`ml-1.5 ${active === g.key ? 'text-primary-100' : 'text-foreground-400'}`}>
                {g.items.length}
              </span>
            </button>
          ))}
        </div>

        {/* 列表内容 */}
        <div className="p-3 md:p-4">
          {archiveGroups.filter((g) => g.key === active).map((g) => (
            <div key={g.key} className="animate-rise space-y-2">
              {g.items.map((it) => (
                <div
                  key={it.id}
                  className="group flex items-center gap-3 rounded-xl border border-background-200/60 bg-background-100/30 px-3.5 py-3 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
                >
                  <span className="flex w-16 shrink-0 font-mono text-[11px] text-foreground-500">{it.time}</span>
                  <a href="#expose-index" className="min-w-0 flex-1 cursor-pointer text-[13px] font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                    {it.title}
                  </a>
                  <span className="flex shrink-0 items-center gap-1 text-[11px] font-bold text-accent-600">
                    <i className="ri-fire-fill text-[11px]"></i> {it.heat}
                  </span>
                  <i className="hidden shrink-0 text-[14px] text-foreground-300 transition-all group-hover:translate-x-0.5 group-hover:text-primary-400 sm:block ri-arrow-right-line"></i>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}